import { LANG_KEY } from "./constants";

export const languageChangeStub = () => Promise.resolve();

export const setAppLanguage = (lang: string) =>
  localStorage.setItem(LANG_KEY, lang);

export const getAppLanguage = () => localStorage.getItem(LANG_KEY);

export const detectLanguage = () => {
  const detectedLanguage = getAppLanguage();

  if (detectedLanguage) {
    return detectedLanguage;
  }

  /**
   * From i18n langDetector plugin
   */
  const found = [];

  if (typeof navigator !== "undefined") {
    if (navigator.languages) {
      for (const element of navigator.languages) {
        found.push(element);
      }
    }

    if (navigator.language) {
      found.push(navigator.language);
    }
  }

  const normalizedLanguages = found.map((lang) => lang.replace("-", "_"));

  return normalizedLanguages.length > 0 ? normalizedLanguages[0] : null;
};
